// Override console.log global (safe)
(function() {
  const originalLog = console.log;
  
  console.log = function() {
    // désactive les logs en production
    return;
  };
})();